// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer2_footer__3TOqT","menu2":"Footer2_menu2__36M4A","link":"Footer2_link__4AZIa","icon1":"Footer2_icon1__2ZQKE","icon2":"Footer2_icon2__7Ym3a","me":"Footer2_me__3YBWn"};